import { decodeHtml } from '~/js/utilities';
import { getProductIntegerId } from '~/js/utilities/product';
import { fetchProducts } from '~js/utilities/products-and-collections';

const matcher = window.matchMedia(`(min-width: 768px)`);

const DESIRED_GROUPS_ORDER = Object.freeze([
  'Limited Edition',
  'Prints',
  'Solids',
  'Core',
]);

const heroProductPrints = (
  currentHandle,
  is_neutrals_campaign,
  show_swatches_from_grouped_products,
  groupedListMetafield = []
) => ({
  expanded: [],
  prints: [],
  visiblePrintsNumber: matcher.matches ? 18 : 14,
  selectedSizeVariant: '',
  shopifySwatchProducts: [],
  currentHandle,
  is_neutrals_campaign,
  show_swatches_from_grouped_products,
  groupedListMetafield,

  get printsIds() {
    return this.groupedListMetafield.map((print) => getProductIntegerId(print));
  },

  get visiblePrints() {
    return DESIRED_GROUPS_ORDER.map((group) => {
      const swatches = this.finalizedPrints
        .filter((product) =>
          product.swatchGroup
            ?.toLowerCase()
            .replace(/\s+/g, '')
            .includes(group.toLowerCase().replace(/\s+/g, ''))
        )
        .sort((a, b) => a.name.localeCompare(b.name));
      const expandable = swatches.length > this.visiblePrintsNumber;
      const expanded = expandable ? this.expanded.includes(group) : true;

      return {
        name: group,
        hasActive: swatches.some(
          (product) => product.handle === this.currentHandle
        ),
        expandable,
        count: swatches.length,
        items: expanded
          ? swatches
          : swatches.slice(0, this.visiblePrintsNumber),
      };
    }).filter((group) => group.items.length > 0);
  },

  init() {
    this.queryPrints();
    this.handleMediaQuery();
    this.handleMediaQuery = this.handleMediaQuery.bind(this);
    matcher.addEventListener('change', this.handleMediaQuery);

    const variantSelectChangeHandler = ({ detail: { selectedOptions } }) => {
      this.selectedSizeVariant = selectedOptions['Size'];
    };

    this.boundVariantSelectChangeHandler =
      variantSelectChangeHandler.bind(this);

    window.addEventListener(
      'product-variant-selection-change',
      this.boundVariantSelectChangeHandler
    );
  },

  destroy() {
    matcher.removeEventListener('change', this.handleMediaQuery);
    window.removeEventListener(
      'product-variant-selection-change',
      this.boundVariantSelectChangeHandler
    );
  },

  get finalizedPrints() {
    return this.shopifySwatchProducts.map((product) => ({
      uid: product.id.replace('gid://shopify/Product/', ''),
      name: decodeHtml(product.title || ''),
      url: `${window.Shopify.routes.root}products/${product.handle}`,
      isActive: product.handle === this.currentHandle,
      isAvailable: product.availableForSale ?? true,
      lastImage: product.images.nodes.at(-1).url,
      swatchGroup: product.swatchGroup?.value,
    }));
  },

  async queryPrints() {
    try {
      const results = await fetchProducts(this.printsIds);
      this.shopifySwatchProducts = this.printsIds
        .map((id) => results[id])
        .filter(Boolean)
        .filter((product) => !!product.availableForSale);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(error);
    } finally {
      this.printsLoading = false;
    }
  },

  handleMediaQuery() {
    this.visiblePrintsNumber = matcher.matches ? 18 : 14;
  },

  togglePrintsGroup(name) {
    if (this.expanded.includes(name)) {
      this.expanded.splice(this.expanded.indexOf(name), 1);
    } else {
      this.expanded.push(name);
    }
  },
});

export default heroProductPrints;
